require( './bootstrap' );

import LazyLoad from "vanilla-lazyload";

document.addEventListener(
    'DOMContentLoaded',
    function () {
        let myLazyLoad = new LazyLoad( {
            elements_selector: ".lazy-load"
        } );
    }
);

$(document).ready(function(){
    $('.main_slider').owlCarousel({
        loop:true,
        nav:false,
        items:1,
        autoplay:true,
        autoHeight: false,
        lazyLoad: true,
    });

    $('.play-btn').on('click', function(){
        $(this).parent('.frame-wrap').addClass('open');
        let idFrame = $(this).parent('.frame-wrap').attr('data-id');
        let parent = $(this).parent('.frame-wrap');
        $('<iframe src="https://www.youtube.com/embed/'+idFrame+'?modestbranding=1&autohide=1&showinfo=0&controls=1&autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope;" allowfullscreen></iframe>')
            .appendTo(parent);
        $(this)
            .next('img')
            .remove()
            .end()
            .remove();

    });
});

document.addEventListener("DOMContentLoaded", readyHTML);
function readyHTML() {
    adapt('940',['#menu-top'],'cover','.headmenu');
}
function toggle_class(togle_cover,click_element,add_class) {
    let cover = document.querySelectorAll(togle_cover);
    if (cover) {
        for (let i = 0; i < cover.length; i++) {
            let elem = cover[i].querySelector(click_element);
            if (elem) {
                elem.addEventListener('click',_toggle);
            }
        }
    }
    function _toggle() {
        this.parentNode.classList.toggle(add_class);
    }
}
function chek_active_and_add_class(chek_item,class_to_faind,add_class) {
    let cover = document.querySelectorAll(chek_item);
    if (cover) {
        for (let i = 0; i < cover.length; i++) {
            let elem = cover[i].querySelector(class_to_faind);
            if (elem) {
                cover[i].classList.toggle(add_class);
            }
        }
    }
}
function move_block(adaptWid,block_to_move,place_to_move) {
    window.addEventListener('resize', _move_resizewindow);
    let place_to = document.querySelector(place_to_move);
    let block_to = document.querySelector(block_to_move);
    if (block_to && place_to) {
        let block = block_to.querySelector('ul');
        let place = place_to.querySelector('ul');
        if (block) block.classList.add('block_to_move');
        if (place) place.classList.add('place_to_move');
    }
    let wid = window.innerWidth;
    _move_resizewindow();
    function _move_resizewindow() {
        wid = window.innerWidth;
        let activeItems;
        if (wid < adaptWid) {
            let activeLiBlock = block.querySelectorAll('li');
            let activeLiPlace = place.querySelectorAll('li');
            if (activeLiBlock) {

            }
            if (block && place) {
                place_to.insertBefore(block, place);
            }
        } else {
            if (block && place) {
                let block_replaced = place_to.querySelector('.block_to_move');
                if (block_replaced) block_to.appendChild(block_replaced);
            }
        }
    }
}
function adapt(adaptWid,menu,covertable,insert_adapt_menu) {
    window.addEventListener('resize', _resizewindow);
    if (covertable && covertable != 'nocover') {
        _coverTable();
    }
    let body = document.querySelector('body');

    function  _coverTable() {
        let table = document.querySelectorAll('table');
        for (let i = table.length - 1; i >= 0; i--) {
            let cover = document.createElement('div');
            cover.classList.add('cover-table');
            table[i].parentNode.insertBefore(cover, table[i]);
            cover.appendChild(table[i]);
        }
    }
    let adapt_menu = [];
    if (menu) {
        for (let l = 0; l < menu.length; l++) {
            adapt_menu[l] = document.querySelectorAll(menu[l]);
        }
    }
    let adapt_menu_cover = document.createElement('div');
    adapt_menu_cover.classList.add('cover-menu');
    body.appendChild(adapt_menu_cover);
    let gamburger = document.querySelector('.adapt-menu-icon');
    if (!gamburger) {
        let gamburger = document.createElement('div');
        gamburger.classList.add('adapt-menu-icon');
        gamburger.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
    }
    let gamburger2 = document.querySelector('.show-menu-icon');
    let bgicon = document.querySelector('.icon-menu-bg');
    if (!bgicon) {
        let bgicon = document.createElement('div');
        bgicon.classList.add('icon-menu-bg');
    }
    let closemenu = document.querySelector('.menu-close-button');
    if (!closemenu) {
        let closemenu = document.createElement('div');
        closemenu.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
        closemenu.classList.add('menu-close-button');
    }

    let menu_menu = document.querySelector(insert_adapt_menu);
    if (gamburger && adapt_menu) {
        if (menu_menu ) {
            menu_menu.appendChild(gamburger);
        }

        gamburger.addEventListener('click', showmenu);}
    if (gamburger2 && adapt_menu) {
        body.appendChild(gamburger2);
        gamburger2.addEventListener('click', showmenu);}
    if (bgicon && adapt_menu) {
        body.appendChild(bgicon);
        bgicon.addEventListener('click',hidemenu);
    }
    if (closemenu && adapt_menu_cover){
        adapt_menu_cover.appendChild(closemenu);
        closemenu.addEventListener('click',hidemenu);
    }
    if (adapt_menu_cover && adapt_menu){
        for (let d = 0; d < adapt_menu.length; d++) {
            for (let f = 0; f < adapt_menu[d].length; f++) {
                adapt_menu_cover.appendChild(adapt_menu[d][f].cloneNode(true));
            }
        }
    }
    let elements = adapt_menu_cover.querySelectorAll('*');
    for (let e = 0; e < elements.length; e++) {
        elements[e].removeAttribute('id');
    }
    _resizewindow();
    function _resizewindow() {
        let wid = window.innerWidth;
        if (wid < adaptWid) {
            if (gamburger) {gamburger.addEventListener('click', showmenu);}
            if (gamburger2) {gamburger2.addEventListener('click', showmenu);}
            if (bgicon) {bgicon.addEventListener('click',showmenu);}
            if (closemenu){closemenu.addEventListener('click',hidemenu);}
        } else {
            if (gamburger) {gamburger.removeEventListener('click', showmenu);gamburger.classList.remove('activeGamburger');}
            if (gamburger2) {gamburger2.removeEventListener('click', showmenu);}
            if (adapt_menu_cover) {adapt_menu_cover.classList.remove('showmenu');}
            if (closemenu){closemenu.removeEventListener('click',hidemenu);}
            if (bgicon) {
                bgicon.classList.remove('showbg');
                bgicon.removeEventListener('click',showmenu);
            }
            if (body) {
                body.classList.remove('OverflowHiden');
            }
        }
    }
    function showmenu() {
        if (gamburger) {
            gamburger.removeEventListener('click',showmenu);
            gamburger.classList.add('activeGamburger');
            gamburger.addEventListener('click',hidemenu);
        }
        if (gamburger2) {
            gamburger2.removeEventListener('click',showmenu);
            gamburger2.addEventListener('click',hidemenu);
        }
        let scrolled = window.pageYOffset || document.documentElement.scrollTop;

        if (adapt_menu_cover) {
            adapt_menu_cover.classList.add('showmenu');
        }
        if (closemenu) {
            closemenu.addEventListener('click',hidemenu);
        }
        if (bgicon) {
            bgicon.classList.add('showbg');
            bgicon.addEventListener('click',showmenu);
        }
        if (body) {
            body.classList.add('OverflowHiden');
        }
    }
    function hidemenu() {
        if (gamburger) {
            gamburger.addEventListener('click',showmenu);
            gamburger.classList.remove('activeGamburger');
            gamburger.removeEventListener('click',hidemenu);
        }
        if (gamburger2) {
            gamburger2.addEventListener('click',showmenu);
            gamburger2.removeEventListener('click',hidemenu);
        }
        if (bgicon) {
            bgicon.classList.remove('showbg');
            bgicon.removeEventListener('click',showmenu);
        }
        if (closemenu) {
            closemenu.removeEventListener('click',hidemenu);
        }
        if (adapt_menu_cover) {
            adapt_menu_cover.classList.remove('showmenu');
        }
        if (body) {
            body.classList.remove('OverflowHiden');
        }
    }
}

!function(){"use strict";!function(){let e=document.getElementById("js_game");e&&function(){let t=e.getElementsByTagName("button")[0];t&&t.addEventListener("click",function n(){let i=document.createElement("iframe"),a=e.getAttribute("data-game");i.setAttribute("src",a);t.removeEventListener("click",n);e.innerHTML="";e.appendChild(i)})}()}()}();
